import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { CountrySectionTitle } from '@/src/domains/countries/CountryDetail';
import { RenderText } from '@/src/domains/notion/RenderText';

export const HeadingSectionWrapper = styled.div`
  counter-reset: country-section;
  background-image: linear-gradient(180deg, rgba(249, 251, 255, 0.9), rgba(240, 245, 255, 0.9));
`;

const Wrapper = styled.section`
  ${fluidProp('--section-spacing-y', '40px', '100px')}
  padding: var(--section-spacing-y) 0;

  color: var(--colors-bayoux);
  line-height: 1.5;

  &:nth-of-type(even) {
    background-color: var(--colors-blank);
  }

  a {
    color: var(--colors-irisBlue);

    :hover {
      text-decoration: underline;
    }

    :focus-visible {
      outline: 1px auto var(--colors-irisBlue);
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--colors-darkBlue);
  }

  ul {
    list-style: none;

    li {
      position: relative;

      &::before {
        content: '\\2022';
        color: #75e8f0;
        position: absolute;
        font-size: 1.42857rem;
        top: -3px;
        left: -24px;
      }
    }
  }

  li + li {
    margin-top: 24px;
  }
`;

export function HeadingSection({ children }) {
  return (
    <Wrapper>
      <ContentContainer>{children}</ContentContainer>
    </Wrapper>
  );
}

export function HeadingSectionTitle({
  rich_text: richText,
  replaceComponents,
  internalHrefResolver,
}) {
  return (
    <CountrySectionTitle>
      <RenderText
        entries={richText}
        replaceComponents={replaceComponents}
        internalHrefResolver={internalHrefResolver}
      />
    </CountrySectionTitle>
  );
}
